export const COPILOT_APP_LAUNCHER_PATH = '/copilot/app/launch'
export const GITHUB_APP_LANDING_PAGE_URL = '/features/ai/github-app'
